import type { Column } from "@tanstack/react-table";
import { Badge } from "../../../components/badge";

type ActiveFilterProps<TData, TValue> = {
	column?: Column<TData, TValue>;
	title?: string;
};

const ActiveFilter = <TData, TValue>({
	column,
	title,
}: ActiveFilterProps<TData, TValue>) => {
	const selectedValues = column?.getFilterValue() as string[];

	return (
		<div className="flex h-full w-full items-center px-2">
			{selectedValues?.length && (
				<div className="flex w-full items-center gap-x-2 text-sm">
					<span className="min-w-max text-xs tracking-wide uppercase">
						{title}
					</span>
					{selectedValues?.length > 2 ? (
						<Badge
							variant="secondary"
							className="min-w-max rounded-sm px-1 font-normal"
						>
							{selectedValues.length}
						</Badge>
					) : (
						selectedValues.map((option, index) => (
							<Badge
								variant="secondary"
								key={option}
								className="min-w-max rounded-sm px-1 font-normal"
							>
								{option}
							</Badge>
						))
					)}
				</div>
			)}
		</div>
	);
};

export { ActiveFilter };
